import React from "react";
import { ReCaptchaProvider, ReCaptchaV2, ReCaptchaV3 } from "react-recaptcha-x";
import * as S from "../styles";

type EmailStepFormProps = {
  email: string;
  error: string;
  loading: boolean;
  disableButton: boolean;
  enableRecaptchaV2: boolean;
  onEmailChange: (email: string) => void;
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
  recaptchaV2Callback: (token: string) => void;
  recaptchaV3Callback: (token: string) => void;
};

export default function EmailStepForm({
  email,
  error,
  loading,
  disableButton,
  enableRecaptchaV2,
  onEmailChange,
  onSubmit,
  recaptchaV2Callback,
  recaptchaV3Callback,
}: EmailStepFormProps): React.ReactElement {
  return (
    <S.Form onSubmit={onSubmit}>
      <S.Field>
        <S.Label htmlFor="login-email">
          E-mail <S.Required>*</S.Required>
        </S.Label>
        <S.Input
          id="login-email"
          name="email"
          type="email"
          value={email}
          onChange={(event) => onEmailChange(event.target.value)}
          disabled={loading}
          autoComplete="email"
        />
      </S.Field>

      <ReCaptchaProvider
        siteKeyV2={process.env.REACT_APP_RECAPTCHA_V2_SITEKEY}
        siteKeyV3={process.env.REACT_APP_RECAPTCHA_V3_SITEKEY}
      >
        {!enableRecaptchaV2 && (
          <ReCaptchaV3
            callback={recaptchaV3Callback}
            action="login_identify"
          />
        )}
        {enableRecaptchaV2 && (
          <ReCaptchaV2 callback={recaptchaV2Callback} className="mt-6" />
        )}
      </ReCaptchaProvider>

      {error && <S.ErrorMessage>{error}</S.ErrorMessage>}

      <S.Button
        type="submit"
        disabled={loading || disableButton || !email.trim()}
      >
        {loading ? "Carregando..." : "Continuar"}
      </S.Button>
    </S.Form>
  );
}
